import React from 'react'
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
const PrimaryGradientButton = ({buttonText, className, onClick=()=>{}, disabled=false, loading=false}) => {
  const [isDisable, setIsDisable] = useState(false);
  function onClickHandler(){
    setIsDisable(true);
    setTimeout(() => {
      setIsDisable(false);
    },500)
    onClick()
  }
  return (
    <>
        <Button className={`primaryBtn ${className}`} onClick={onClickHandler} disabled={(disabled || isDisable)}>{loading ?<i class="fa fa-spinner fa-spin"></i> : buttonText}</Button>
    </>
  )
}

export default PrimaryGradientButton